import { useRef } from 'react';
import { CLINIC_MARKETPLACE_PAGE } from 'constants/pages';
import ChevronLeft from 'svg/ChevronLeft';
import ChevronRight from 'svg/ChevronRight';
import { AvailableClinicsProps } from 'screens/PlayerLoggedInScreen/props';
import CardsSection from 'components/CardSection';
import classNames from 'styles/utils/classNames';
import AvailableClinicCard from './AvailableClinicCard';
import EmptyState from '../EmptyState';
import IconActionLink from 'components/IconActionLink';

const AvailableClinics: React.FC<AvailableClinicsProps> = ({ clinics, loading }) => {
  const prevArrowRef = useRef<HTMLDivElement>(null);
  const nextArrowRef = useRef<HTMLDivElement>(null);

  const getArrow = (type: 'prev' | 'next') => {
    if (type === 'prev') {
      return (
        <div
          ref={prevArrowRef}
          className="grid h-10 w-10 place-items-center rounded-full bg-color-bg-lightmode-primary shadow-[0px_4px_16px_0px_rgba(0,0,0,0.08)] dark:bg-color-bg-lightmode-primary"
        >
          <ChevronLeft className="h-4 w-4" />
        </div>
      );
    } else {
      return (
        <div
          ref={nextArrowRef}
          className="grid h-10 w-10 place-items-center rounded-full bg-color-bg-lightmode-primary shadow-[0px_4px_16px_0px_rgba(0,0,0,0.08)] dark:bg-color-bg-lightmode-primary"
        >
          <ChevronRight className="h-4 w-4" />
        </div>
      );
    }
  };

  return (
    <div
      className={classNames(
        'container mx-auto mt-[1.6rem] border-b border-color-bg-input-lightmode-primary pb-ds-2xl dark:border-color-bg-input-darkmode-primary',
        clinics.length > 0 ? 'max-sm:pl-4' : 'max-sm:px-4',
      )}
    >
      <div className="mb-5 flex justify-between  gap-2 max-sm:mb-3">
        <h3 className="typography-product-heading-desktop max-sm:typography-product-heading-mobile">
          Group clinics available
        </h3>

        <div className={classNames('hidden items-center gap-2', clinics.length > 0 && 'sm:!flex')}>
          {getArrow('prev')}
          {getArrow('next')}
        </div>
      </div>
      {!loading && clinics.length === 0 && (
        <EmptyState
          href={CLINIC_MARKETPLACE_PAGE}
          title="Find Clinics"
          text="You don’t have Clinics available. Try another location or follow new coaches."
        />
      )}
      <CardsSection
        loading={loading}
        scrollOffset={{
          base: 0,
          xs: 40,
          lg: 0,
        }}
        visibleCards={{
          base: 1,
          xs: 1,
          md: 1,
          lg: 2,
        }}
        gap="1rem"
        externalPrevArrowRef={prevArrowRef}
        externalNextArrowRef={nextArrowRef}
        data={clinics}
        renderCard={(clinic) => <AvailableClinicCard clinic={clinic} />}
        affix={
          <IconActionLink title="Find more clinics" className="pl-12" href={CLINIC_MARKETPLACE_PAGE} />
        }
      />
    </div>
  );
};

export default AvailableClinics;
